import * as Yup from 'yup';

export const GenericFormValidationSchema = Yup.object().shape({
  is_active: Yup.bool().oneOf([false, true]).required('errors.required'),
  name: Yup.string().required('errors.required'),
});
